export default [
  {
    title: 'Home',
    component: 'Home',
    path: '/'
  },
  {
    title: 'My Profile',
    component: 'Profile',
    path: '/profile'
  },
  {
    title: 'Blogs',
    component: 'Blog',
    path: '/blog/the-kickness-project'
  },
  {
    title: 'About',
    component: 'About',
    path: '/about'
  }
]
